module.exports = __webpack_public_path__ + "img/topic.c786901b.jpg";